import React, { useEffect, useRef, useState } from "react";
import { cdnImg } from "../Utils/cdnImage";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { t } from "i18next";
import { FaWhatsapp } from "react-icons/fa";
import ConditionalOutsideClick from "./ConditionalOutsideClick";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { pick } from "lodash";
const Login = () => {
  const setUser = useContextSelector(AuthContext, (ctx) => ctx.setUser);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(true);
  const handleShow = () => {
    setShowPassword(!showPassword);
  };
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    unregister,
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
      uniqueId: Math.random() * 10000,
    },
  });
  const canvasRef = useRef(null);
  const [getValidateCode, setValidateCode] = useState("");

  let loginUser = async (body) => {
    setLoading(true);

    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    body.website = hostname || "SABAEXCH";
    const { status, data } = await apiPost(
      apiPath.loginUser,
      pick(body, ["username", "password", "uniqueId", "website"]),
    );
    if (data.success) {
      localStorage.setItem("chatId", data.results.platformType);
      localStorage.setItem("token", data.results.token);
      localStorage.setItem("refresh_token", data.results.refresh_token);
      setUser(jwt_decode(data.results.token));
      if (data?.results?.isPasswordReset) {
        navigate("/reset-password");
      } else {
        navigate("/");
      }
    } else {
      toast.error(data?.message);
    }
    setLoading(false);
  };

  const changeCode = () => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    context.font = "bold 110px sans-serif";
    const code = Math.floor(1000 + Math.random() * 9000);
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.fillText(code, 10, 116);
    setValidateCode(code);
  };
  useEffect(() => {
    changeCode();
  }, []);
  const onSubmit = (data) => {
    loginUser(data);
  };

  return (
    <div className="popup-page popup-page--active popup-page--align-top">
      <div className="popup-page__backdrop" />

      <ConditionalOutsideClick onOutsideClick={() => navigate(-1)}>
        <div className="popup-page__main popup-page-main popup-page-main--show">
          <div className="popup-page-main__header">
            <div className="popup-page-main__title">{t("Login")}</div>
            <div
              onClick={() => navigate("/")}
              className="popup-page-main__close ng-star-inserted"
            />
          </div>
          <div className="popup-page-main__container">
            <div className="content login-biometric-content">
              <div className="login-image">
                <p>
                  <span>প্রতারণার হাত থেকে বাঁচতে</span> সবার আগে
                  <br />
                  এজেন্টকে ভেরিফাই করুন <a href="#">KHELMU.com</a> ভিজিট করে ।
                </p>
                <img
                  style={{ width: "100%" }}
                  src={cdnImg("/assets/Other/logo-dark.png")}
                  alt=""
                />
                <p className="subtext">
                  আপনার সকল অভিযোগ জানাতে কিংবা যেকোনো সমস্যায় মেসেজ দিন
                </p>
                <a href="https://khelmu.com/support" className="wabtn">
                  {" "}
                  <FaWhatsapp />
                  +19784445407
                </a>
              </div>

              <Form
                onSubmit={handleSubmit(onSubmit)}
                className="ng-untouched ng-pristine ng-invalid ng-star-inserted"
              >
                <div className="menu-box">
                  <div className="input-group-wrapper">
                    <div className="input-group">
                      <label htmlFor="userId">{t("Username")}</label>
                      <input
                        removewhitespace
                        type="text"
                        className="input ng-untouched ng-pristine ng-invalid"
                        name="userId"
                        placeholder={t("Username")}
                        {...register("username", {
                          required: t("Enter_Username"),
                        })}
                      />
                      <input type="button" className="clear" />
                    </div>
                    {errors.username && errors.username.message && (
                      <div className="alert">{errors.username.message}</div>
                    )}
                  </div>
                  <div className="input-group-wrapper">
                    <div className="input-group password">
                      <div
                        onClick={() => handleShow()}
                        _ngcontent-serverapp-c2292208966
                        className={`eyes ${!showPassword ? "active" : ""} `}
                      />
                      <label htmlFor="password">{t("Password")}</label>
                      <input
                        className="input ng-untouched ng-pristine ng-invalid"
                        type={!showPassword ? "text" : "password"}
                        name="password"
                        placeholder={t("Password")}
                        {...register("password", {
                          required: t("Enter_Password"),
                          minLength: {
                            value: 6,
                            message: t("PasswordMin"),
                          },
                          maxLength: {
                            value: 20,
                            message: t("PasswordMax"),
                          },
                        })}
                      />
                    </div>
                    {errors.password && errors.password.message && (
                      <div className="alert">{errors.password.message}</div>
                    )}
                  </div>

                  <div className="input-group-wrapper">
                    <div
                      style={{ position: "relative" }}
                      className="input-group password"
                    >
                      <label htmlFor="password">{t("VerificationCode")}</label>
                      <input
                        className="input ng-untouched ng-pristine ng-invalid"
                        type={"text"}
                        placeholder={t("VerificationCode")}
                        {...register("validateCode", {
                          required: t("Enter_Vadlidation"),
                          validate: {
                            validate: (value) =>
                              parseInt(value) === parseInt(getValidateCode) ||
                              t("InvalidValidateCode"),
                          },
                        })}
                        onChange={(e) => {
                          if (e.target.value.length == 4) {
                            e.target.blur();
                            unregister("validateCode", { keepValue: true });
                          }
                        }}
                      />{" "}
                      <canvas
                        ref={canvasRef}
                        onClick={changeCode}
                        className="inputcanvas"
                        id="authenticateImage"
                      />
                    </div>
                    {errors.validateCode && errors.validateCode.message && (
                      <div className="alert">{errors.validateCode.message}</div>
                    )}
                  </div>
                </div>

                <button
                  className="button btn-primary app-style"
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "white",
                    fontSize: "15px",
                    fontWeight: "600",
                    width: "stretch",
                  }}
                  type="submit"
                >
                  {loading ? (
                    <div
                      _ngcontent-serverapp-c381631582=""
                      class="btn-loading"
                    ></div>
                  ) : (
                    t("Login")
                  )}
                </button>
                <p className="signup">
                  <span>{t("Donothaveanaccount")} </span>
                  <a
                    href="https://khelmu.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("SignUp")}
                  </a>
                </p>
              </Form>
            </div>
          </div>
        </div>
      </ConditionalOutsideClick>
    </div>
  );
};

export default Login;
